// ForgotPassword.js (JavaScript) - Version: v1 i1

import { useState } from "react";
import BackButton from "./BackButton";
import "./Login.css"; // Einheitliches Styling für alle Auth-Seiten

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const logo = "/logo192.png"; // Logo aus /public/-Ordner laden

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setMessage("");

    console.log("🔍 handleForgotPassword wurde aufgerufen mit:", email);

    if (!email) {
      setMessage("❌ Bitte eine gültige E-Mail-Adresse eingeben.");
      return;
    }

    try {
      const response = await fetch("https://freiseinapp.de/api/forgot_password.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      console.log("🔍 API-Response:", data);

      if (data.success) {
        setMessage("✅ E-Mail zum Zurücksetzen gesendet! Bitte prüfe dein Postfach.");
      } else {
        setMessage(data.message || "❌ Fehler beim Senden der E-Mail.");
      }
    } catch (error) {
      console.error("❌ Fehler bei der Anfrage:", error);
      setMessage("❌ Netzwerkfehler. Bitte versuche es später erneut.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img src={logo} alt="FreiSeinApp Logo" className="login-logo" />
        <h2>🔑 Passwort zurücksetzen</h2>
        <form onSubmit={handleForgotPassword}>
          <input
            type="email"
            placeholder="E-Mail-Adresse"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit">Passwort zurücksetzen</button>
        </form>
        {message && <p className="login-message">{message}</p>}
        
        <BackButton />
      </div>
    </div>
  );
}
